import React from "react";
import { ReactLenis } from "lenis/react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import ProcessTimeline from "./components/ProcessTimeline";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import HealthTools from "./components/HealthTools";

function App() {
  return (
    <ReactLenis
      root
      options={{
        lerp: 0.1,
        duration: 1.5,
        smoothWheel: true,
        wheelMultiplier: 1.2,
      }}
    >
      <div className="min-h-screen bg-background font-sans text-foreground">
        <WhatsAppWidget />
        <Navbar />
        <main>
          <Hero />
          <About />
          <Services />
          <HealthTools />
          <Gallery />
          <ProcessTimeline />
          <FAQ />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
